/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  dataReport.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/3/22 10:19
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const dataReportRouter = [
    {
        path: '/dataReport',
        name: 'DataReport',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/index.vue'),
        meta: {
            title: '数据分析',
            keepAlive: false,
            deepth: 1,
            permission: true
        },
    },
    {
        path: '/returnGoodsOrder',
        name: 'ReturnGoodsOrder',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/ReturnGoodsOrder.vue'),
        meta: {
            title: '退单商品统计',
            keepAlive: true,
            deepth: 2,
          permission: false
        },
    },
    {
        path: '/goodsOrder',
        name: 'GoodsOrder',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/GoodsOrder.vue'),
        meta: {
            title: '订单商品统计',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/orderMonitor',
        name: 'OrderMonitor',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/OrderMonitor.vue'),
        meta: {
            title: '订单监控',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/orderMonitor',
        name: 'OrderMonitor',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/OrderMonitor.vue'),
        meta: {
            title: '订单监控',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/employeeKpi',
        name: 'EmployeeKpi',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/EmployeeKpi.vue'),
        meta: {
            title: '员工业绩',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/employeeNew',
        name: 'EmployeeNew',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/EmployeeNew.vue'),
        meta: {
            title: '员工拉新',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/areaReport',
        name: 'AreaReport',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/AreaReport.vue'),
        meta: {
            title: '地区统计',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/saleReport',
        name: 'SaleReport',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/SaleReport.vue'),
        meta: {
            title: '商品销售',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/orderReport',
        name: 'OrderReport',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/OrderReport.vue'),
        meta: {
            title: '客户订货',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/kpiMoreFilter',
        name: 'KpiMoreFilter',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/KpiMoreFilter.vue'),
        meta: {
            title: '更多筛选',
            deepth: 3
        },
    },
    {
        path: '/areaMoreFilter',
        name: 'AreaMoreFilter',
        component: () =>
            import(/* webpackChunkName: "dataReport" */ '@/views/dataReport/AreaMoreFilter.vue'),
        meta: {
            title: '更多筛选',
            deepth: 3
        },
    },
]

export default dataReportRouter
